module.exports = __webpack_public_path__ + "media/honey-icons/icon-door-sensor-7df47c21.svg";